import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-column ga-2 mb-5"
}
const _hoisted_2 = { class: "file-title" }

import Card from "@intec/vue-components/form/Card.vue";
import FileInput from '@intec/vue-components/form/FileInput.vue';
import { ref } from "vue";
import { SUPPLIER_REQUIREMENT_TYPE } from "@/lib/supplierRequirement";
import { formatDate } from "@/filters";
import { useI18n } from 'vue-i18n';

interface SupplierRequirementFile {
  id: number;
  name: string;
  downloadUrl: string;
  [key: string]: any;
}

interface SupplierRequirementValue {
  id: number;
  supplierRequirementId: number;
  type: string;
  name: string;
  valueText?: string;
  valueNumber?: number;
  valueBool?: boolean;
  valueDate?: Date;
  valueList?: number;
  list?: Array<{ id: number; value: string }>;
  valueFile?: SupplierRequirementFile;
  [key: string]: any;
}

interface Props {
  noCard?: boolean;
  supplierRequirementValues: SupplierRequirementValue[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SupplierRequirementValuesView',
  props: {
    noCard: { type: Boolean },
    supplierRequirementValues: {}
  },
  setup(__props: any) {

const props = __props;
const { t } = useI18n()

const panel = ref(0); // с 0 - панель открыта по умолчанию.
const title = t('Требования к участнику ({_1})', { '_1': props.supplierRequirementValues.length })

const isShowFile = (requirementValue: SupplierRequirementValue): boolean => {
  return requirementValue.type === SUPPLIER_REQUIREMENT_TYPE.FILE
    && !!requirementValue.valueFile;
};

// Функция для отображения значения в зависимости от типа.
const displayRequirementValue = (requirementValue: SupplierRequirementValue): string | number => {
  switch (requirementValue.type) {
    case SUPPLIER_REQUIREMENT_TYPE.TEXT:
      return requirementValue.valueText || 'Не указано';
    case SUPPLIER_REQUIREMENT_TYPE.NUMBER:
      return requirementValue.valueNumber || 'Не указано';
    case SUPPLIER_REQUIREMENT_TYPE.DATE:
      return requirementValue.valueDate
        ? formatDate(requirementValue.valueDate.toISOString())
        : 'Не указано';
    case SUPPLIER_REQUIREMENT_TYPE.BOOL:
      return requirementValue.valueBool ? 'Да' : 'Нет';
    case SUPPLIER_REQUIREMENT_TYPE.LIST:
      const selected = requirementValue.list?.find(
        (item) => item.id === requirementValue.valueList
      );
      return selected?.value || 'Не выбрано';
    case SUPPLIER_REQUIREMENT_TYPE.FILE:
      return 'Не приложен';
    default:
      return 'Не указано';
  }
};

const downloadSupplierRequirementDocument = async (requirementValue: SupplierRequirementValue) => {
  window.location.href = requirementValue?.valueFile?.downloadUrl;
};


return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!

  return (_openBlock(), _createBlock(Card, {
    class: _normalizeClass(["container", {'no-card': _ctx.noCard}])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_expansion_panels, {
        modelValue: panel.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((panel).value = $event)),
        flat: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_expansion_panel, { title: _unref(title) }, {
            default: _withCtx(() => [
              _createVNode(_component_v_expansion_panel_text, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.supplierRequirementValues, (requirementValue, index) => {
                    return (_openBlock(), _createElementBlock("div", { key: index }, [
                      (isShowFile(requirementValue))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                            _createElementVNode("div", _hoisted_2, _toDisplayString(requirementValue.name), 1 /* TEXT */),
                            _createVNode(FileInput, {
                              title: "Файл",
                              "without-title": "",
                              "no-card": "",
                              "without-sub-title": "",
                              documents: requirementValue.valueFile ? [requirementValue.valueFile] : [],
                              "download-file": () => downloadSupplierRequirementDocument(requirementValue)
                            }, null, 8 /* PROPS */, ["documents", "download-file"])
                          ]))
                        : (_openBlock(), _createBlock(_component_v_text_field, {
                            key: 1,
                            style: {"pointer-events":"none"},
                            variant: "underlined",
                            readonly: "",
                            label: requirementValue.name,
                            "model-value": _ctx.$t(String(displayRequirementValue(requirementValue)))
                          }, null, 8 /* PROPS */, ["label", "model-value"]))
                    ]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["title"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["modelValue"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["class"]))
}
}

})